module.exports = __webpack_public_path__ + "static/media/img85.e90041c0.jpg";